// extracted by mini-css-extract-plugin
export default {"container":"_1fe3df82"};